import {
  AppState,
  Auth0Provider,
  Auth0ProviderOptions,
} from "@auth0/auth0-react";
import { useNavigate } from "react-router-dom";

/**
 * Auth0 inside the router. After login it goes back to the page that sent
 * the user to log in, query string included (a meeting request email's
 * link, say), through the router. Auth0's default only rewrote the address
 * bar, which React Router doesn't see, so the app stayed on the landing page.
 */
export default function Auth0ProviderWithNavigate({
  children,
  ...options
}: Auth0ProviderOptions) {
  const navigate = useNavigate();
  return (
    <Auth0Provider
      {...options}
      onRedirectCallback={(appState?: AppState) =>
        navigate(appState?.returnTo || window.location.pathname, {
          replace: true,
        })
      }
    >
      {children}
    </Auth0Provider>
  );
}
